import React from "react";
import styled from "styled-components";

import Text from "./Text";
const constants = require("../constants");

const heights = {
  lg: constants.buttons.height.lg + "px",
  md: constants.buttons.height.md + "px",
};
const paddings = {
  lg: constants.buttons.padding.lg,
  md: constants.buttons.padding.md,
};

const backgroundColor = constants.buttons.background.normal;
const hoverBackgroundColor = constants.buttons.background.hover;
const disableBackgroundColor = constants.buttons.background.disable;
const disableTextColor = constants.buttons.text.disable;

export default function Button(props) {
  const {
    size,
    outline,
    type = "primary",
    icon,
    css = {},
    disabled = false,
    ...rest
  } = props;

  const color = outline ? "#FF5520" : "#ffffff";

  return (
    <Wrapper
      onClick={props.onClick}
      size={size}
      css={css}
      type={type}
      disabled={disabled}
      {...rest}
    >
      <Text color={color} size="sm" weight={500}>
        {props.children}
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.button`
  display: flex;
  min-width: 96px;
  padding: ${props => paddings[props.size] || paddings.md};
  height: ${props => heights[props.size] || heights.md};
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 12px;
  background: ${props =>
    backgroundColor[props.type] || backgroundColor.primary};
  color: ${props => props.color || "#ffffff"};
  outline: ${props => (props.outline ? "1.2px solid #FF5520" : "none")};
  border: ${props => (props.outline ? "1.2px solid #FF5520" : "none")};
  cursor: pointer;

  &:hover {
    background: ${props =>
      hoverBackgroundColor[props.type] || hoverBackgroundColor.primary};
  }

  &:disabled {
    background: ${props =>
      disableBackgroundColor[props.type] || disableBackgroundColor.primary};
    cursor: not-allowed;

    & > div {
      color: ${props =>
        disableTextColor[props.type] || disableTextColor.primary};
    }
  }

  ${props => props.css}
`;
